import { Controller } from "stimulus"

export default class extends Controller {
  reRenderSurveyTemplateSelector({ target }) {
    $.ajax({
      url: `/accounts/${target.dataset.accountId}/program_automation_rules/program_type_change`,
      type: 'GET',
      data: { program_type: target.options[target.selectedIndex].value },
    })
  }
}
